import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Box, Typography, CircularProgress
} from '@mui/material';
import CommodityAutocomplete from './Common/CommodityAutocomplete';

const AssignCommodityDialog = ({ open, onClose, selectedCount, onAssign, isAssigning }) => {
  const [commodity, setCommodity] = useState('');
  const [subCommodity, setSubCommodity] = useState('');

  useEffect(() => {
    if (open) {
      setCommodity('');
      setSubCommodity('');
    }
  }, [open]);

  const handleAssign = () => {
    onAssign(commodity, subCommodity);
  };

  const hasValue = commodity !== '' || subCommodity !== '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Assign Commodity</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Assign commodity to {selectedCount} selected image(s). Leave a field empty to keep its current value.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <CommodityAutocomplete
            value={commodity}
            onChange={(val) => setCommodity(val)}
            label="Commodity"
            size="medium"
          />
          <TextField
            fullWidth
            label="Sub-Commodity"
            value={subCommodity}
            onChange={(e) => setSubCommodity(e.target.value)}
            placeholder="Enter sub-commodity number"
            size="medium"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isAssigning}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleAssign}
          disabled={!hasValue || isAssigning}
          startIcon={isAssigning ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {isAssigning ? 'Assigning...' : 'Assign'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignCommodityDialog;
